module.exports = __webpack_public_path__ + "assets/Retina-MediumItalic.e7de3e1a20759e318191a8d552dcbdda.woff2";